import { useIsCurrentPageType } from '@avensia/excite';

export * from './cart';

export {
  send,
  cartUpdateEvent,
  isAddLineItemCommand,
  isChangeLineItemQuantityCommand,
  isRemoveLineItemCommand,
} from './cart/command';

export type { CustomerAddressType } from './customer';
export {
  changeCustomerEmail,
  changeMobileNumber,
  setDateOfBirth,
  createCustomer,
  setCustomerAddress,
  resetPassword,
  forgotPassword,
} from './customer';

export { login, logout } from './authentication';

export {
  addWishListItem,
  removeWishListItem,
  useItemExistsInWishList,
  useWishListCount,
  wishlistUpdateEvent,
  WishlistUpdateCommand,
} from './wishlist';

export function isErrorResponse<T extends Excite.ContentApi.IDynamicData>(
  response: T | Excite.Commercetools.CartValidationApiModel,
): response is Excite.Commercetools.CartValidationApiModel {
  return typeof (response as Excite.Commercetools.CartValidationApiModel).hasErrors === 'boolean';
}

export function isSuccessfulResponse<T extends Excite.ContentApi.IDynamicData>(
  response: T | Excite.Commercetools.CartValidationApiModel,
): response is T {
  return !isErrorResponse(response);
}

export function useCurrentPageIsCheckoutPage() {
  return useIsCurrentPageType<Excite.Commerce.ICheckoutPageApiModel>();
}

export * from './customer-types';
